import { ZodTypeAny } from 'zod';

// Validate a request body against the shared contract before the network call.
// Failures throw in the same shape as the backend's 400 so existing
// error.response?.data?.error handling displays them unchanged.
export function preflight(schema: ZodTypeAny, body: unknown): void {
  const result = schema.safeParse(body);
  if (result.success) return;
  const issue = result.error.issues[0];
  const path = issue.path.join('.');
  const message = path ? `${path}: ${issue.message}` : issue.message;
  const err = new Error(message) as Error & { response: { status: number; data: { success: false; error: string } } };
  err.response = { status: 400, data: { success: false, error: message } };
  throw err;
}
